module.exports = __webpack_public_path__ + "img/electronic_electric_no_zone.8edfd6d1.svg";